import { merge } from '../../../helper';

import type { CustomFile } from '../types';

import type { TypeUploadConfig, TypeUploadResultPromise } from './types';
import sendUpload from './sendUpload';

// ----------------------------------------------------------------------------

/*
 * Sequential mode: one request at a time, in the order the files were given. Kept as its own name
 * because "sequential" reads better at a call site than `concurrency: { max: 1 }`, but it is that.
 */
function sendSequentialFiles(files: CustomFile[], config: TypeUploadConfig): TypeUploadResultPromise {
    /*
     * The caller's `merge` is resolved first: it outranks plain keys, so setting the cap after it
     * is what stops a consumer's merge from quietly restoring concurrency to this mode.
     */
    return sendUpload(files, { ...merge({}, config), concurrency: { enabled: true, max: 1 } });
}

// ----------------------------------------------------------------------------

export default sendSequentialFiles;
